<template>
<div class="logreg" :class="{showContent: showContent}" >

    <div class="close" @click="back()"></div>

    <div class="login" v-if="isShowLogin">
        <div class="head" ></div>
        <!-- <p class="guide" >Log-in to experience more features</p> -->
        <select-way
            :wayType="wayType"
            @selectWay="selectWayHandle"
        >
        </select-way>
        <email-way ref="emailWay" v-if="showContent && wayType === 'email'" @showForget="showForgetHandle" @success="success" @fail="fail" :wayType="wayType"></email-way>
        <phone-way ref="phoneWay" v-if="showContent && wayType === 'phone'" @showForget="showForgetHandle" @success="success" @fail="fail" :wayType="wayType"></phone-way>
        <third-way :clientId="clientId" :thirdHost="thirdHost" :oldThirdHost="oldThirdHost" :wayType="wayType"></third-way>
        <p class="notice">
            <i18n :path="$loginLangPrefix('userSign.termstip')" tag="p">
                <a place="term" target="_blank" href="/protocol/terms.html">{{ $t($loginLangPrefix('userSign.term')) }}</a>
                <a place="privacy" target="_blank" href="/protocol/privacy.html">{{ $t($loginLangPrefix('userSign.privacy')) }}</a>
            </i18n>
            <!-- Click to read <a target="_blank" href="//www.liveme.com/protocol/terms.html">Terms of Service</a> and <a target="_blank" href="//www.liveme.com/protocol/privacy.html">Privacy Policy</a> -->
        </p>
    </div>
    <div class="forget" v-if="!isShowLogin">
        <email-forget v-if="forgetState === 'email'" :wayType="wayType" :loginName="loginName" @selectWay="selectWayHandle" @success="success" />
        <phone-forget v-if="forgetState === 'phone'" :wayType="wayType" :loginName="loginName" :itc="itc" @selectWay="selectWayHandle" @success="success" />
    </div>

</div>
</template>
<script>

import util from '@utils/util';
import emailWay from './email';
import phoneWay from './phone';
import selectWay from './select';
import thridWay from './third';
import emailForget from './email/forget';
import phoneForget from './phone/forget';

export default {
    name: 'logreg',
    props: {
        thirdHost: { type: String, default: '' },
        oldThirdHost: { type: String, default: '' },
        clientId: { type: String, default: '' },
        showContent: { type: Boolean, default: false },
        // inHome: { type: Function, default: () => {} },
        // updateUserInfo: { type: Function, default: () => {} },
        close: { type: Function, default: () => {} },
        success: { type: Function, default: () => {} },
        fail: { type: Function, default: () => {} }
    },
    components: {
        'select-way': selectWay,
        'email-way': emailWay,
        'phone-way': phoneWay,
        'third-way': thridWay,
        'email-forget': emailForget,
        'phone-forget': phoneForget
    },
    data() {
        return {
            wayType: 'email',
            isShowLogin: true,
            forgetState: '',
            loginName: '',
            itc: ''
        };
    },
    computed: {
    },
    methods: {
        showForgetHandle(type, name, itc) {
            this.isShowLogin = false;
            this.forgetState = type;
            this.loginName = name;
            this.itc = itc;
        },
        selectWayHandle(type) {
            this.isShowLogin = true;
            this.wayType = type;
        },
        back() {
            this.close();
            util.KEWLSensorTrack({ lmweb_clickText: '关闭登陆' });
        }
    },

    watch: {
        showContent(val) {
            if (!val) {
                this.wayType = 'email';
                this.isShowLogin = true;
            }
        }
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
@function rem($n) {
    @return ($n*1rem / 50);
}

.logreg {
    // 50
    font-size: 0;
    position: absolute;
    overflow: hidden;
    width: 400px;
    background-color:rgba(255,255,255,1);
    border-radius:12px;
    transition: all 200ms linear;
    padding: 40px;
    box-sizing: border-box;
    transform: scale(0.7);
    opacity: 0;
    &.showContent {
        transform: scale(1);
        opacity: 1;
    }
    .head {
        position: relative;
        width: 100%;
        height: 76px;
        background-image: url('./images/liveme.png');
        background-repeat: no-repeat;
        background-size: 110px 40px;
        background-position: center top;
    }
    .close {
        display: block;
        position: absolute;
        width: 30px;
        height: 30px;
        background-image: url('./images/close.png');
        background-repeat: no-repeat;
        background-size: 30px 30px;
        background-position: center center;
        right: 16px;
        top: 16px;
        cursor: pointer;
    }
    .return {
        display: none;
    }
    .guide {
        display: none;
    }
    .notice {
        margin-top: 20px;
        width: 100%;
        text-align: center;
        font-size:12px;
        font-family: 'RobotoRegular';
        font-weight: normal;
        color:rgba(153,153,153,1);
        line-height:14px;
        a {
            color:rgba(153,153,153,1);
            text-decoration: underline;
            cursor: pointer;
        }
    }
}
</style>
